export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
export const MAX_UPLOAD_LABEL = '10 MB';

export const MAX_PROFILE_PICTURE_BYTES = 10 * 1024 * 1024;
export const MAX_PROFILE_PICTURE_LABEL = '10 MB';
export const ACCEPTED_UPLOAD_MIME = 'image/*,video/*,audio/*';

// Mirrors VARCHAR(256) on posts.content and comments.content
export const POST_CONTENT_MAX = 256;
export const COMMENT_CONTENT_MAX = 256;
